import Cookies from "js-cookie";

const PROD_LOGIN_URL = "https://apps.spanidea.com/login";

/**
 * True when the UI is running on a local development host.
 */
export const isLocalDevHost = () => {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
};

/**
 * Login URL: env override, otherwise production SSO.
 * On localhost we never force-navigate to production login.
 */
export const getLoginUrl = () =>
  process.env.REACT_APP_LOGIN_URL || PROD_LOGIN_URL;

/**
 * Redirect to SSO login — skipped on localhost so local testing
 * is not kicked out to https://apps.spanidea.com/login.
 */
export const redirectToLogin = () => {
  if (isLocalDevHost()) {
    console.warn(
      "[auth] Login/session missing on localhost — staying here (not redirecting to production SSO). Set a valid `token` cookie for local testing."
    );
    return;
  }
  window.location.href = getLoginUrl();
};

/**
 * Read JWT from the `token` cookie.
 * Supports Express-style `j:{"token":"<jwt>"}` and a raw JWT string.
 */
export const getAuthToken = () => {
  const raw = Cookies.get("token");
  if (!raw) return null;

  if (raw.startsWith("j:")) {
    try {
      const parsed = JSON.parse(raw.slice(2));
      return parsed?.token || null;
    } catch (error) {
      console.warn("[auth] Failed to parse j: token cookie", error);
      return null;
    }
  }

  return raw;
};
